import { useNavigate } from "react-router-dom";
import Layout from "../../components/global/layout";
import { useEffect, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import { useParams } from "react-router-dom";
import loader from "../../methods/loader";
import { Tooltip } from "antd";
import methodModel from "../../methods/methods";

const View = () => {
  const [data, setData] = useState()
  const history = useNavigate()
  const { id } = useParams()

  useEffect(() => {
    getDetail()
  }, [])

  const getDetail = () => {
    loader(true)
    ApiClient.get(`category/detail?id=${id}`).then((res) => {
      loader(false)
      if (res.success) {
        setData(res.data)
      }
    })
  }

  return (
    <>
      <Layout>
        <div className="bg-white shadow-box rounded-lg w-full p-4 ">
          <div className="flex items-center mb-8">
            <Tooltip placement="top" title="Back">
              <span onClick={() => history(-1)} className="!px-4  py-2 cursor-pointer flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all  mr-3">
                <i className="fa fa-angle-left text-lg"></i>
              </span>
            </Tooltip>
            <div>
              <h3 className="text-lg lg:text-2xl font-semibold text-[#111827]">Category Details</h3>
            </div>
          </div>
          <div className="flex flex-col gap-y-6">
            <div className="col-span-12 md:col-span-6">
              <div className="">
                <p className=" flex md:items-center flex flex-col md:flex-row font-semibold capitalize">
                  <span className="inline-flex md:w-96 text-md text-gray-600">Name:</span>
                  {data?.name || "--"}
                </p>
              </div>
            </div>
            <div className="col-span-12 md:col-span-6">
              <div className="">
                <p className=" flex md:items-center flex flex-col md:flex-row font-semibold">
                  <span className="inline-flex md:w-96 text-md text-gray-600">Image:</span>
                  <img src={methodModel.noImg(data?.image)} className="h-32 mr-auto" />
                </p>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default View;
